/**
 * @generated SignedSource<<ff3ac94b645c5c248c068041377cc162>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaEditorUploadMutation$variables = {
  connections: ReadonlyArray<string>;
  file: any;
  mediableId: string;
  position?: number | null;
};
export type MediaEditorUploadMutation$data = {
  readonly uploadMedia: {
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"MediaEditorThumb_media">;
    } | null;
  } | null;
};
export type MediaEditorUploadMutation = {
  response: MediaEditorUploadMutation$data;
  variables: MediaEditorUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "file"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mediableId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "position"
},
v4 = [
  {
    "kind": "Variable",
    "name": "file",
    "variableName": "file"
  },
  {
    "kind": "Variable",
    "name": "mediableId",
    "variableName": "mediableId"
  },
  {
    "kind": "Variable",
    "name": "position",
    "variableName": "position"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MediaEditorUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UploadMediaResult",
        "kind": "LinkedField",
        "name": "uploadMedia",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Media",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MediaEditorThumb_media"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MediaEditorUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UploadMediaResult",
        "kind": "LinkedField",
        "name": "uploadMedia",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Media",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "size",
                    "value": "S120X120"
                  }
                ],
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": "externalUrl(size:\"S120X120\")"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "size",
                    "value": "w262"
                  }
                ],
                "kind": "ScalarField",
                "name": "src",
                "storageKey": "src(size:\"w262\")"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "MediaEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d416fe993a22984945a1acee2a74909",
    "id": null,
    "metadata": {},
    "name": "MediaEditorUploadMutation",
    "operationKind": "mutation",
    "text": "mutation MediaEditorUploadMutation(\n  $mediableId: ID!\n  $position: Int\n  $file: Upload!\n) {\n  uploadMedia(mediableId: $mediableId, position: $position, file: $file) {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n"
  }
};
})();

(node as any).hash = "53427347e3440ed1c79a6cc610da3964";

export default node;
